<script lang="ts">
	import { HandShakeIcon, PaintIcon } from "luxedo-icons"
	import { NewSceneController } from "./NewSceneController"
	import { Responsive } from "responsive"

	let isMobile = $derived(Responsive.isMobile)
</script>

<div id="scene-type-selection" class:isMobile>
	<button class="type-button standard-select" onclick={NewSceneController.selectStandard}>
		<PaintIcon />
		<span class="type-select-text">Create your Own</span>

		<span class="show-on-hover"
			>Use the Luxedo scene editor or create a scene or use a 3rd party video editing software.</span
		>
	</button>
	<div class="seperate"></div>
	<button class="type-button custom-select" onclick={NewSceneController.selectCustom}>
		<HandShakeIcon />
		<span class="type-select-text">Work with a Professional</span>
		<span class="show-on-hover"
			>Work with one of our trusted partners to create a custom show designed specifically for you.</span
		>
	</button>
</div>

<style>
	:global(.overlay.new-scene-overlay):has(:global(#scene-type-selection)) {
		min-width: unset;
		min-height: unset;
		height: 100%;
	}

	.seperate {
		height: 100%;
		width: 1px;
		background-color: var(--color-border);
	}

	#scene-type-selection {
		display: flex;
		flex-direction: row;
		height: 100%;
	}

	#scene-type-selection.isMobile {
		flex-direction: column;
	}

	.type-button {
		display: flex;
		flex-direction: column;
		border-radius: unset;
		background-color: unset;
		flex-basis: 50%;
		height: 100%;
		align-items: center;
		justify-content: center;
		box-shadow: none;
	}

	.type-select-text {
		font-size: var(--h1);
		font-family: var(--font-heading);
		color: var(--color-text);
		transition: color 250ms;
	}

	.type-button {
		transform: unset;
		transition:
			background-color 300ms,
			transform 500ms;
	}

	.show-on-hover {
		text-align: center;
		padding: 0 2rem;
		opacity: 0;
		transition: opacity 500ms;
	}

	.isMobile .show-on-hover {
		opacity: 1;
		line-height: 1.25rem;
	}

	.isMobile .seperate {
		height: 1px;
		width: 100%;
		background-color: var(--color-border);
	}

	.type-button:hover .show-on-hover,
	.type-button:focus-visible .show-on-hover {
		opacity: 1;
	}

	.type-button:hover,
	.type-button:focus-visible {
		background-color: var(--color-bg-dark);
	}

	.isMobile .type-button {
		background-color: unset;
	}

	.type-button :global(svg) {
		width: 50%;
		height: auto;
	}

	.isMobile .type-button :global(svg) {
		width: auto;
		height: 30%;
	}

	.type-button :global(.svg-fill) {
		fill: var(--color-text);
		transition: fill 250ms;
	}

	.type-button:hover .type-select-text,
	.type-button:focus-visible .type-select-text,
	.isMobile .type-select-text {
		color: var(--color-main);
	}

	.type-button:hover :global(.svg-fill),
	.type-button:focus-visible :global(.svg-fill),
	.isMobile .type-button :global(.svg-fill) {
		fill: var(--color-main);
	}

	.isMobile .type-button {
		transform: unset;
	}
</style>
